<template>


  <div v-if="show"
       class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5">
    <a-spin :spinning="submitting">
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0 pt-0.5">
            <img class="h-10 w-10 rounded-full" :src="user.profile_photo_path" alt=""/>
          </div>
          <div class="ml-3 w-0 flex-1">
            <p class="text-lg font-bold font-medium text-gray-900">
              {{ user.username }}
            </p>
            <p class="mt-1 text-sm text-gray-500">
              Accept <label class="text-gray-600 font-bold">{{ user.email }}</label> to be your team member?
            </p>
            <div class="mt-4 flex">
              <button
                  class="inline-flex items-center px-10 bg-white rounded-md bg-green-100 hover:bg-green-50 py-1 px-1"
                  @click="handleApprove(user)">
                <CheckIcon class="flex-shrink-0 h-5 w-5 font-bold text-green-400"/>
              </button>

              <button
                  class="ml-3 inline-flex px-10 items-center bg-white rounded-md bg-red-100 hover:bg-red-50 py-1 px-1"
                  @click="handleReject(user)">
                <XIcon class="flex-shrink-0 h-5 w-5 font-bold text-red-400"/>
              </button>

            </div>
          </div>

        </div>
      </div>
    </a-spin>
  </div>


</template>

<script>
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {CheckIcon, XIcon, MailIcon, CheckCircleIcon} from '@heroicons/vue/solid'
import {ref} from "vue";

export default {
  components: {
    XIcon,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    CheckCircleIcon,
    CheckIcon,
    MailIcon,
  },
  emits: ['reject', 'approve'],
  props: {
    user: {
      type: Object,
    },
  },
  setup(props, {emit}) {
    const show = ref(true)
    const submitting = ref(false);
    const handleApprove = async (user) => {
      submitting.value = true;
      emit('approve', user);

    };
    const handleReject = async (user) => {
      submitting.value = true;
      emit('reject', user);
    };
    return {
      handleApprove,
      submitting,
      handleReject,
      show,
    }
  },
}
</script>